import { CheckIcon, CloseIcon, UnCheckIcon } from '@/components/icons'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Menu,
  Stack,
  Typography,
} from '@mui/material'
import Divider from '@mui/material/Divider'
import { useState, useEffect } from 'react'
import classes from './SensorHeader.module.scss'
import { useAppDispatch, useAppSelector } from '@store/stores'
import {
  stationGeoTagDeviceSliceActions,
  stationGeoTagDeviceState,
} from '@store/slices/StataionGeoTagDevice/stationGeoTagDeviceSlice'
import useTranslation from '@/hooks/useTranslation'

interface MenuFilterSensorTypeProps {
  anchorEl?: null | HTMLElement
  onClose?: () => void
}

const MenuFilterSensorType = ({ anchorEl, onClose }: MenuFilterSensorTypeProps) => {
  const { t } = useTranslation()
  const open = Boolean(anchorEl)

  const dispatch = useAppDispatch()
  const stationGeoTagDevice = useAppSelector(stationGeoTagDeviceState)
  const availableTypes = stationGeoTagDevice.sensorTypes
  const appliedTypes = stationGeoTagDevice.filterSensor.Types

  const [pendingTypes, setPendingTypes] = useState<string[]>([])

  useEffect(() => {
    if (open) setPendingTypes([...appliedTypes])
  }, [open])

  const handleToggle = (type: string) => {
    setPendingTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type],
    )
  }

  const handleReset = () => {
    setPendingTypes([])
    dispatch(stationGeoTagDeviceSliceActions.setSensorTypeFilter([]))
  }

  const handleFilter = () => {
    dispatch(stationGeoTagDeviceSliceActions.setSensorTypeFilter(pendingTypes))
    onClose?.()
  }

  return (
    <Menu
      id="sensor-type-filter-menu"
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      sx={{
        padding: 0,
        borderRadius: '5px',
        border: '1px solid #D7D7D7',
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
      }}
    >
      <Box sx={{ width: '320px', padding: '7px 16px 20px 16px' }}>
        <Stack direction="row" justifyContent="space-between">
          <Typography color="text.main" className={classes.textSiteLocation}>
            {t('filterByType')}
          </Typography>
          <Box color="text.main">
            <CloseIcon onClick={onClose} cursor="pointer" />
          </Box>
        </Stack>

        <Box className={classes.groupSiteLocation}>
          <Stack
            sx={{
              overflowY: 'scroll',
              borderRadius: '5px',
              maxHeight: '195px',
              '&::-webkit-scrollbar': { width: '4px' },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#A5A5A5',
                borderRadius: '5px',
              },
            }}
          >
            {availableTypes.map((type) => (
              <FormControlLabel
                key={type}
                label={type}
                control={
                  <Checkbox
                    checked={pendingTypes.includes(type)}
                    onChange={() => handleToggle(type)}
                    checkedIcon={<CheckIcon sx={{ color: '#004744 !important' }} />}
                    icon={<UnCheckIcon />}
                    sx={{
                      padding: 0,
                      margin: '0px 11px 2px 11px',
                      '& .MuiSvgIcon-root': { fontSize: 16, color: 'text.main', mt: '3px' },
                    }}
                  />
                }
                sx={{
                  paddingBottom: '8px',
                  alignItems: 'flex-start',
                  '& .MuiTypography-root': {
                    color: 'text.main',
                    fontWeight: '500',
                    lineHeight: '16px',
                    mt: '3px',
                  },
                }}
              />
            ))}
          </Stack>
        </Box>
      </Box>

      <Divider sx={{ width: '100%' }} />
      <Stack
        justifyContent="space-between"
        px="16px"
        pt="10px"
        pb="10px"
        direction="row"
      >
        <Button variant="secondary" className={classes.btnReset} onClick={handleReset}>
          {t('commonActionsReset')}
        </Button>
        <Button variant="primary" className={classes.btnFilter} onClick={handleFilter}>
          {t('commonActionsFilter')}
        </Button>
      </Stack>
    </Menu>
  )
}

export default MenuFilterSensorType
